import React, { useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";

export default function Logo() {
  const {
    homeUrl,
    logo,
  } = useContext(CarOrderingContext)

  return (
    <a className='logo' href={homeUrl}>
      <img src={logo.url} alt={logo.alt}/>
    </a>
  )
}
